<template>
  <div class="az-form-content">
    <div v-if="isPossuiParticipantes">
      <v-btn color="primary" dark v-if="licitacao.status === 'ABERTO' && !analiseSolicitacaoCredenciamentoEmAnalise && edicao"
             @click="iniciarAnaliseSolicitacaoCredenciamento()">
        INICIAR ANÁLISE
      </v-btn>
      <v-btn color="primary" dark v-if="licitacao.status === 'ABERTO' && analiseSolicitacaoCredenciamentoEmAnalise && edicao"
             @click="finalizarAnaliseSolicitacaoCredenciamentoAtual()">
        FINALIZAR ANÁLISE
      </v-btn>
      <listagem-selecao-participantes :itens="itens"
                                      :key="key"
                                      :paginas="paginas"
                                      :total-itens="totalItens"
                                      :quantidadeItensCredenciamento="quantidadeItensCredenciamento"
                                       @eventUpdate="update"
                                      :paginacao="$store.state.credenciamento.paginacao"
                                      @paginar="eventoPaginarSolicitacoesCredenciamento">
      </listagem-selecao-participantes>
    </div>
    <div v-else>
      <credenciamento-selecao-participantes-vazio></credenciamento-selecao-participantes-vazio>
    </div>
  </div>
</template>

<script>

import ListagemSelecaoParticipantes from './selecaoparticipantes/ListagemSelecaoParticipantes.vue'
import CredenciamentoSelecaoParticipantesVazio
  from "@/views/credenciamento/detalhe-credenciamento/orgao/selecaoparticipantes/CredenciamentoSelecaoParticipantesVazio.vue";
import {mapActions, mapState, mapMutations} from "vuex";
import {actionTypes, mutationTypes} from "@/commons/constants";
import store from "@/commons/store";

export default {
  name: 'CredenciamentoAtualizacaoSelecaoParticipantes',
  components: {ListagemSelecaoParticipantes, CredenciamentoSelecaoParticipantesVazio},
  data() {
    return {
      edicao: false,
      licitacaoId: null,
      isPossuiParticipantes: false,
      analiseSolicitacaoCredenciamentoEmAnalise: null,
      paginas: 0,
      totalItens: 0,
      itens: [],
      key: 0,
      quantidadeItensCredenciamento: null
    }
  },
  async mounted() {
    this.habilitarLoadingGlobal()
    this.licitacaoId = this.$route.params.id
    this.edicao = this.deveEditar()
    await this.buscarSolicitacoes()
    await this.buscarAnaliseSolicitacaoCredenciamento()
    this.desabilitarLoadingGlobal()
  },
  methods: {

    update(){
      this.key++
    },
    deveEditar(){
      let isEdicao = this.$route.query.edicao
      return !!(isEdicao && store.state.perfilCredenciamentoEdicao.value)
    },
    async buscarSolicitacoes() {
      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Carregando Solicitações Credenciamento...')
      const resultado = await this.buscarSolicitacaoCredenciamento(this.licitacaoId)
      this.isPossuiParticipantes = resultado.totalElements > 0
      if (this.isPossuiParticipantes) {
        this.itens = resultado.solicitacoes
        this.quantidadeItensCredenciamento = resultado.quantidadeItensCredenciamento
        this.paginas = resultado.totalPages
        this.totalItens = resultado.totalElements
      }
      this.desabilitarLoadingGlobal()
    },
    eventoPaginarSolicitacoesCredenciamento(paginacao) {
      this.setPaginacaoSelecaoParticipantes(paginacao)
      this.buscarSolicitacoes()
    },
    async buscarAnaliseSolicitacaoCredenciamento() {
      this.habilitarLoadingGlobal()
      this.analiseSolicitacaoCredenciamentoEmAnalise = await this.buscarAnaliseSolicitacaoCredenciamentoEmAnalise(this.licitacaoId)
      this.desabilitarLoadingGlobal()
    },
    async iniciarAnaliseSolicitacaoCredenciamento() {
      try {
        this.habilitarLoadingGlobal()
        await this.inserirAnaliseSolicitacaoCredenciamento(this.licitacaoId)
        await this.buscarAnaliseSolicitacaoCredenciamento()
        this.desabilitarLoadingGlobal()
        this.mostrarNotificacaoSucessoDefault()
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    },
    async finalizarAnaliseSolicitacaoCredenciamentoAtual() {
      try {
        this.habilitarLoadingGlobal()
        let params = {licitacaoId: this.licitacaoId, analiseSolicitacaoCredenciamentoId: this.analiseSolicitacaoCredenciamentoEmAnalise.id}
        await this.finalizarAnaliseSolicitacaoCredenciamento(params)
        await this.buscarAnaliseSolicitacaoCredenciamento()
        await this.buscarSolicitacoes()
        await this.buscarRelatoriosAnalisesSolicitacoesCredenciamento(this.licitacaoId)
        await this.buscarLicitacao(this.licitacaoId)
        this.desabilitarLoadingGlobal()
        this.mostrarNotificacaoSucessoDefault()
      } catch (e) {
        this.desabilitarLoadingGlobal()
      }
    },
    ...mapActions({
      buscarSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_SOLICITACAO_CREDENCIAMENTO,
      inserirAnaliseSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.INSERIR_ANALISE_SOLICITACAO_CREDENCIAMENTO,
      buscarAnaliseSolicitacaoCredenciamentoEmAnalise: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_ANALISE_SOLICITACAO_CREDENCIAMENTO_EM_ANALISE,
      finalizarAnaliseSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.FINALIZAR_ANALISE_SOLICITACAO_CREDENCIAMENTO,
      buscarRelatoriosAnalisesSolicitacoesCredenciamento: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO,//NOSONAR
      buscarLicitacao: actionTypes.BUSCAR_LICITACAO,
    }),
    ...mapMutations({
      setPaginacaoSelecaoParticipantes: mutationTypes.CREDENCIAMENTO.SET_PAGINACAO_SELECAO_PARTICIPANTES,
    })
  },
  computed: {
    ...mapState(['licitacao']),
  },
}
</script>
